import { render, staticRenderFns } from "./Givings.vue?vue&type=template&id=138cd25b&"
import script from "./Givings.vue?vue&type=script&lang=js&"
export * from "./Givings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports